import styled from 'styled-components';

import Colors from '@rockalingua/ui/constants/Colors';
import MediaQueryBreakpoints from '@rockalingua/ui/constants/MediaQueryBreakpoints';
import { variantStyles as textVariantStyles } from '../Typography/Text.styled';

export const Container = styled.div`
  display: flex;
  gap: 16px;
  border: 2px solid ${Colors.NEUTRAL_VARIANTS[20]};
  border-radius: 12px;
  padding: 12px;
  background-color: ${Colors.WHITE};

  @media only screen and (max-width: ${MediaQueryBreakpoints.md}px) {
    align-items: center;
    padding: 12px;
    gap: 12px;
  }
`;

export const IconContainer = styled.div<{ $bgColor?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: ${({ $bgColor }) => $bgColor};
  flex-shrink: 0;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`;

export const Title = styled.div`
  ${textVariantStyles['title-small-grey-22']}
  color: ${Colors.BLACK};

  @media only screen and (max-width: ${MediaQueryBreakpoints.md}px) {
    ${textVariantStyles['grey-16-bold']}
  }
`;

export const Subtitle = styled.div`
  ${textVariantStyles['grey-16-medium']}
  color: ${Colors.BLACK};

  @media only screen and (max-width: ${MediaQueryBreakpoints.md}px) {
    ${textVariantStyles['dm-14-regular']}
  }
`;
